// extracted by mini-css-extract-plugin
module.exports = {"container":"card-unauthorized_container__xTd-K","button":"card-unauthorized_button__2I4tj","background":"card-unauthorized_background__1DWvv"};